import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent SkeletonText
 */ const SkeletonTextHeading = createComponent({
    displayName: 'SkeletonTextHeading',
    root: 'div',
    propConfig: {
        classNames: [
            'swan-skeleton-text-heading swan-bgc-loading-shimmer'
        ]
    }
});

export { SkeletonTextHeading };
